import Vue from 'vue';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject('error');
};

export default (userId) => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.put(`/account/${userId}/off_debug_mode`)
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/account/offDebugMode.js